var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroductionAcces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 3.2c-7.939 0-14.4 6.461-14.4 14.4v8h-24c-2.646 0-4.8 2.154-4.8 4.8v25.6c0 2.646 2.154 4.8 4.8 4.8h32c2.646 0 4.8-2.154 4.8-4.8v-25.6c0-2.646-2.154-4.8-4.8-4.8h-4.8v-8c0-6.176 5.024-11.2 11.2-11.2s11.2 5.024 11.2 11.2v3.2c0 0.883 0.717 1.6 1.6 1.6s1.6-0.717 1.6-1.6v-3.2c0-7.939-6.461-14.4-14.4-14.4zM36.8 28.8c0.883 0 1.6 0.717 1.6 1.6v25.6c0 0.883-0.717 1.6-1.6 1.6h-32c-0.883 0-1.6-0.717-1.6-1.6v-25.6c0-0.883 0.717-1.6 1.6-1.6h32z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductionAcces);
export default __webpack_public_path__ + "static/media/introduction-acces.4b8d70d8249248107ed01e24e32e250c.svg";
export { ForwardRef as ReactComponent };